import React from 'react';
import '../assets/license.css'
import '../assets/app.css'
import '../App.css'
import DiscountApi from '../api/discount'
import LoadingOverlay from 'react-loading-overlay-ts';

export default class ChangeCCOnline extends React.Component {

    constructor(props) {
        super(props)
        this.localhostName = window.location.origin;
        this.state = {
            loading: true,
            showText: true,
        };
        // this.init()
    }

    async componentDidMount() {
       const query = new URLSearchParams(window.location.search);
       const orderid = query.get('orderid');
       let discountOrderById = await DiscountApi.findDiscountByOrderId(orderid) 
       console.log(discountOrderById)
       window.location = this.localhostName + discountOrderById
    }

    render() {
        const { showText, loading } = this.state
        return (
            <>
                { loading && <div className="dark-background">
                <LoadingOverlay
                        className="_loading_overlay_content"
                    active={loading}
                        spinner
                        text={showText ? '' : 'Processing...'}>
                        
                </LoadingOverlay>
                </div>}               
            </>
        )
    }

    
}
